<template>
  <div class="sf-intro">
    <div class="sf-intro__card">
      <div class="sf-intro__avatar-wrap">
        <img
          v-if="persona.imageUrl"
          :src="persona.imageUrl"
          :alt="persona.label"
          class="sf-intro__avatar"
        />
        <div v-else class="sf-intro__avatar sf-intro__avatar--placeholder" aria-hidden="true"></div>
      </div>

      <h1 class="sf-intro__greeting">Hoi, ik ben {{ persona.label }}, jouw gids!</h1>
      <p v-if="persona.tagline" class="sf-intro__tagline">{{ persona.tagline }}</p>

      <div class="sf-intro__actions">
        <button class="sf-intro__cta" @click="$emit('start')">
          Laten we beginnen
        </button>
        <a :href="selectorUrl" class="sf-intro__back-link">
          Kies ander persoon
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonaIntro',

  props: {
    persona: { type: Object, required: true },
    selectorUrl: { type: String, default: '/verhaalvinder' },
  },

  emits: ['start'],

  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.sf-intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 80vh;
  padding: 48px 16px 24px;
  background-color: #517b86;

  &__card {
    background-color: #e8ddc9;
    border-radius: 20px;
    padding: 32px 24px 24px;
    width: 100%;
    max-width: 358px;
    text-align: center;
  }

  &__avatar-wrap {
    margin: 0 auto 16px;
    width: 84px;
    height: 84px;
  }

  &__avatar {
    width: 84px;
    height: 84px;
    border-radius: 50%;
    object-fit: cover;

    &--placeholder {
      background-color: #b5afa5;
    }
  }

  &__greeting {
    font-family: 'Comfortaa', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: #23201e;
    margin: 0 0 8px;
  }

  &__tagline {
    font-size: 14px;
    color: #23201e;
    margin: 0 0 24px;
    opacity: 0.75;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    margin-bottom: 8px;
  }

  &__cta {
    background: #517b86;
    color: #fff;
    border: none;
    border-radius: 24px;
    padding: 12px 32px;
    font-family: 'Comfortaa', sans-serif;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s ease;
    width: 100%;

    &:hover {
      background: #3d6370;
    }

    &:active {
      transform: scale(0.98);
    }

    &:focus-visible {
      background: #3d6370;
      outline: 2px solid #23201e;
      outline-offset: 2px;
    }
  }

  &__back-link {
    font-family: 'Comfortaa', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #23201e;
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.2s ease, opacity 0.2s ease;

    &:hover,
    &:focus-visible {
      color: #3d6370;
      text-decoration: underline;
    }
  }
}
</style>
